import { apiUrl } from "../../utils/url";
import {
  ProductTypeRefOption,
  RefOption,
  RefOptionWithChildren,
} from "../agenda/types";
import { HttpClient } from "../HttpClient";
import { IRefOptionsService } from "./IRefOptionsService";

export class RefOptionsService implements IRefOptionsService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }
  async getOptionCodes(): Promise<string[]> {
    try {
      return await this.httpClient.get<string[]>("/refOptions/code");
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar as opções do formulário. Atualize a página e tente novamente.",
      );
    }
  }

  async getOptionsByCode(code: string): Promise<RefOption[]> {
    try {
      return await this.httpClient.get<RefOption[]>(
        `/refOptions/code/${encodeURIComponent(code)}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar as opções do formulário. Atualize a página e tente novamente.",
      );
    }
  }

  async getServiceOptions(): Promise<Omit<RefOptionWithChildren, "child">[]> {
    try {
      return await this.httpClient.get<Omit<RefOptionWithChildren, "child">[]>(
        "/refOptions/serviceTypes",
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar as opções do formulário. Atualize a página e tente novamente.",
      );
    }
  }

  async getProductOptions(): Promise<ProductTypeRefOption[]> {
    try {
      return await this.httpClient.get<ProductTypeRefOption[]>(
        "/refOptions/productTypes",
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar as opções do formulário. Atualize a página e tente novamente.",
      );
    }
  }
}
